export default "__VITE_ASSET__Dzvesx$0__"